import React from "react"
import "./TermsAndPrivacy.css"
import SiteContainer from "../SiteContainer"

const TermsAndPrivacy = () => {
    return (
        <div className="terms-and-privacy-container">
            <h2>About Us</h2>
            <p>
                This App has been developed by the Monash Center for Health Research and
                Implementation (MCHRI). MCHRI is a partnership organisation with Monash
                University and Monash Health.
            </p>
            <p>
                Monash Center for Health Research and Implementation (MCHRI) is a
                leading research and implementation unit that aims to create,
                synthesise, implement and translate clinical, health care and public
                health knowledge, underpinned by cross-sector end-user engagement, to
                deliver health impact. Monash University is listed in the top 1% of
                universities worldwide. Monash Health is the largest health service in
                the state of Victoria located across Melbourne, Australia.
            </p>
            <p>
                AskPCOS is a comprehensive, evidence-based App on Polycystic Ovary Syndrome (PCOS).
                It has been designed together with women, for women, in collaboration with world renowned
                PCOS experts.
            </p>
            <h2>We are leading PCOS experts</h2>
            <p>
                The Monash Centre for Health Research and Implementation (MCHRI) and Monash
                University, has led the development of the first international evidence-based guidelines for
                the diagnosis and management of Polycystic Ovary Syndrome (2018) across 37 medical
                societies and 71 counties.
            </p>

            <h2>Terms of Use & Privacy Policy</h2>
            <p>
                Important: Please read carefully. This App is owned and operated by
                Monash University (ABN 12 377 614 012) of Wellington Road, Clayton,
                Victoria, 3800, Australia ("Monash University"). By accessing and/or
                using this App and related services, or by applying to register for an
                account on this App ("Account"), you agree to these terms and conditions
                ("terms").
            </p>
            <p>
                By applying to register for an account or using this App, you will be
                assumed to have accepted these terms. If you do not wish to accept these
                terms you must not use this App or apply to register for an account. In
                these Terms, "you" and "your" means any person who registers or applies
                to register for an account or accesses or uses this App.
            </p>
            <p>
                Monash University values the privacy of every individual's personal and
                health information and is committed to the protection of personal
                information. When you use the App information about you will be
                collected and used in accordance with the consent you provide us when
                you sign up to use the application, and otherwise in accordance with
                these terms and conditions. Monash University will otherwise manage and
                store your information as set out in our Data Protection and Privacy
                Procedure. You can find more information in our <a href="https://aus01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.monash.edu%2F__data%2Fassets%2Fpdf_file%2F0003%2F790086%2FPrivacy.pdf&data=04%7C01%7Cdkumar%40vichealth.vic.gov.au%7Cd8ad0e1911c441f014e808d90506f19f%7C7a9289642e45446db6276e3a00389297%7C0%7C0%7C637546350856434302%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000&sdata=KKAPet1xdbzJ6DFhAnsEAvSx93arjPuXcW6qtF7bnY8%3D&reserved=0"> Data Protection and
                    Privacy Procedure </a>or by contacting dataprotectionofficer@monash.edu.
            </p>
            <p>
                Personal and health information is handled in accordance with the
                Privacy and Data Protection Act 2014 (Vic), the Health Records Act 2001
                (Vic), as well as the European Union General Data Protection Regulation
                2016/679 (EU) where applicable.
            </p>
            <p>
                THE INFORMATION AND MATERIAL PROVIDED THROUGH THIS APP IS PROVIDED FOR
                GENERAL INFORMATIONAL PURPOSES ONLY. IT SHOULD NOT BE USED OR RELIED ON
                AS MEDICAL ADVICE OR TO DIAGNOSE, TREAT, CURE OR PREVENT ANY MEDICAL
                CONDITION. WHILE CARE HAS BEEN TAKEN IN CREATING THIS APP, MONASH
                UNIVERSITY DOES NOT WARRANT OR REPRESENT THAT ANY INFORMATION OR
                MATERIAL PROVIDED THROUGH THIS APP IS ACCURATE, COMPLETE, UP TO DATE OR
                SUITABLE FOR ANY PURPOSE. USERS ACCESS THIS APP AND RELY ON THE
                INFORMATION AND MATERIAL PROVIDED THROUGH IT AT THEIR OWN RISK.
            </p>

            <h2>1. Registration</h2>
            <p>
                You must have successfully registered for an Account to access certain
                features of this App and purchase products. After you successfully
                register for and activate your Account, the user name and password you
                have provided must be kept secure and you are responsible for all use
                and activity carried out under this user name or using your Account.
                Your Account is non-transferrable.
            </p>
            <p>
                By applying to register for an Account, you:
                <ul className="list-disc list-inside">
                    <li>warrant that you are at least 16 years of age;</li>
                    <li>
                        warrant that you possess the legal right and ability to enter into a
                        legally binding agreement with Monash University; and
                    </li>
                    <li>
                        agree and warrant to use this App in accordance with these Terms.
                    </li>
                </ul>
            </p>

            <h2>2. Account information</h2>
            <p>
                You warrant that all information supplied to Monash University as part of your application to
                register for an Account is true and correct. You acknowledge that Monash University may
                take such steps as it is able to take to verify the information provided by you before deciding
                whether to provide you with an Account. If Monash University considers (in its sole
                discretion) that any of that information provided by you is untrue, Monash University
                reserves the right to reject your application for an Account or to cancel your Account and
                terminate your access to the features of this App which are only accessible by registered
                account holders. You indemnify Monash University from and against any and all liability, loss,
                damage and costs (including legal costs) arising from its use of or reliance upon the
                information contained in your application to register for an Account, or supplied by you
                through your Account.
            </p>

            <h2>3. Information we collect</h2>
            <p>
                The App collects the following personal data in line with the use purposes explained in a
                subsequent section:
                <ul className="list-disc list-inside">
                    <li>your display name</li>
                    <li>your email address (for the purpose to log-on)</li>
                    <li>phone number (optional)</li>
                    <li>your year of birth (optional)</li>
                    <li>PCOS diagnosis (optional)</li>
                    <li>country of residence (optional)</li>
                    <li>height and weight (optional)</li>
                    <li>information preferences (optional)</li>
                    <li>PCOS self-diagnosis quiz responses (optional)</li>
                    <li>selected QPL personalised questions to ask doctor (optional)</li>
                    <li>simple search queries</li>
                    <li>browsed PCOS topics, common questions and articles</li>
                    <li>preferred articles</li>
                    <li>duration of use of this App</li>
                </ul>
            </p>

            <h2>4. Use of your information</h2>
            <p>
                The App uses your personal information for the following purposes:
                <ol className="list-decimal list-inside">
                    <li>To create a user profile and log in.</li>
                    <li>
                        To provide information based on your needs and respond to your
                        requests. The App may use your personal information to provide you
                        with notices of new events and updates.
                    </li>
                    <li>
                        To provide targeted content to you and to improve your experience
                        within the App.
                    </li>
                    <li>
                        The App may use your personal information, including the information gathered as a
                        result of App navigation and electronic protocols, to help create and personalise App
                        content, improve App quality, evaluate page response rates, conduct usability testing,
                        and facilitate your use of the App (for example, to facilitate navigation and the login
                        process, avoid duplicate data entry, and enhance security).
                    </li>
                    <li>
                        To get feedback or input from you. In order to deliver information services of most
                        interest to our customers, from time to time, we may ask App users to provide us
                        input and feedback (for example through surveys, usability studies, focus groups,
                        research opportunities).
                    </li>
                    <li>
                        To protect the App information assets as well as your own personal data. The
                        Monash University Information Security Program protects the confidentiality, integrity,
                        and availability of App information assets by following a risk management approach
                        based on policies, standards, guidelines, and procedures to meet security objectives
                        while supporting research and operational goals.
                    </li>
                    <li>
                        We may use de-identified data to further PCOS research to help us understand the
                        condition better and to contribute best practice and treatment of PCOS. We are a non
                        for profit research organisation. All of the results of our research are provided free of
                        charge to health professionals and women with PCOS.
                    </li>
                </ol>
            </p>

            <h2>5. Your control your own information</h2>
            <p>
                You can control your information. If you are a registered user, you can
                review, revise, and correct the personal data that you have provided to
                the App.
            </p>
            <p>
                If you would like to request access to or correction of your personal
                information from our database, please contact
                dataprotectionofficer@monash.edu.
            </p>

            <h2>6. Your Privacy</h2>
            <p>
                We respect your privacy. We want to ensure that you get the information,
                content, and experiences that matter most to you. You agree that Monash
                University may collect and deal with personal information about you or
                others in accordance with the Monash University Privacy Collection
                Statement, which can be found at
                <a href="https://www.monash.edu/privacy-monash/privacy-collection-statements">
                    <br />https://www.monash.edu/privacy-monash/privacy-collection-statements
                </a>
                .
            </p>
            <p>
                You warrant that you have obtained the consent of any person whose
                personal information is as a result of anything done by you collected
                and uploaded through this App. For any person who is under 16 years of
                age, if you are not their parent or legal guardian, you warrant that you
                have obtained the consent of their parent or legal guardian to that
                person's personal information being collected and uploaded through this
                App as a result of anything done by you.
            </p>

            <h2>7. Security</h2>
            <p>
                You may select or be allocated codes or other information (such as a username and
                password) to log in to Monash University's computer systems as a result of successfully
                registering for an Account ("Log In Details"). You must keep your Log In Details secure and
                confidential. If you believe that your Log In Details have been compromised, you must tell
                Monash University immediately or change them on this App through the facilities provided.
            </p>
            <p>
                Monash University is entitled to assume that you are the person gaining
                access to any part of this App that is only accessible to registered
                account holders or Monash University's computer systems through the use
                of your Log In Details, and you will be responsible for what is done
                while using your Log In details, unless you have given Monash University
                reasonable prior notice that your Log In Details have been compromised
                and new Log In Details have not yet been allocated to or selected by
                you. You must make sure that your computer systems are protected by up
                to date anti-virus software and take all reasonable steps to prevent any
                malicious software (such as "viruses", "worms", "cancelbots", "trojan
                horses", "phishers", "bombs", "trapdoors", "spyware" or other software,
                data or routines designed to disrupt or provide unauthorised access to
                systems or data) from being uploaded to or accessing Monash University's
                systems.
            </p>

            <h2>8. Intellectual Property</h2>
            <p>
                Unless otherwise indicated, Monash University owns or has been granted
                licences by third parties that own all rights, title and interest
                (including copyright, designs, patents, registered and unregistered
                trademarks and other intellectual property rights) in and to this App
                and all of the material (including all text, graphics, logos, audio and
                software) made available on or provided through this App ("Content").
            </p>

            <h2>9. Purpose of use</h2>
            <p>
                Subject to your compliance with these Terms, Monash University grants
                you a royalty-free, non-exclusive, non-transferable, limited licence to
                use this App and the Content and view this App and the Content for
                personal non-commercial purposes only. Unless you have obtained Monash
                University's prior written permission, you must not use this App or the
                Content for any other purpose or do any of the following:
                <ul>
                    <li>
                        copy, distribute, sell, rent or modify any part of this App or the
                        Content;
                    </li>
                    <li>
                        reverse engineer, decompile, disassemble or otherwise derive or
                        attempt to derive the source code of any part of this App or the
                        Content (except to the extent permitted by non-excludable applicable
                        law), or tamper with any part of this App or the Content in a way
                        that disables, circumvents, or otherwise defeats any protection
                        mechanisms that have been applied to this App or the Content;
                    </li>
                    <li>
                        operate this App for the benefit of any other person, whether as an
                        online service, outsourced service, comparison service or otherwise;
                    </li>
                    <li>
                        remove, alter or add to any trademark or copyright notice or similar
                        marking applied to the Content or within this App; or
                    </li>
                    <li>
                        extract any data from any of the databases used by or forming part
                        of this App, or resell or distribute that data in any way.
                    </li>
                </ul>
            </p>

            <h2>10. Enforcement of Intellectual Property</h2>
            <p>
                Monash University reserves the right to enforce its intellectual
                property rights in the Content or this App through civil proceedings.
            </p>

            <h2>11. Prohibited Activities</h2>
            <p>
                You must not do any act that Monash University (acting reasonably)
                considers is inappropriate or which is unlawful or prohibited by any
                laws applicable to this App, including but not limited to:
                <ul>
                    <li>
                        any act that would constitute a breach of either the privacy
                        (including by uploading through this App personal or health
                        information without an individual's consent) or any other of the
                        legal rights of individuals;
                    </li>
                    <li>
                        using this App to defame or libel Monash University, its employees
                        or other individuals;
                    </li>
                    <li>
                        uploading files (whether deliberately, negligently or as a result of
                        failure to take reasonable steps) that contain viruses or other
                        software, data or routines that may cause damage to, disrupt or
                        provide unauthorised access to Monash University's computer systems,
                        data or other property or the property of other individuals;
                    </li>
                    <li>
                        posting on or transmitting to this App any non-authorised material
                        including, but not limited to, material that is, in Monash
                        University's opinion, likely to cause annoyance, or which is
                        defamatory, racist, obscene, threatening, pornographic or otherwise
                        detrimental to or in violation of Monash University's systems or
                        network security or a third party's systems or network security.
                    </li>
                </ul>
            </p>

            <h2>12. User Content</h2>
            <p>
                Monash University may allow you to post information to this App ("User
                Content"), and retains the right to take down the User Content at its
                sole discretion and without notice. You grant Monash University a
                royalty-free, non-exclusive, non-transferable, limited licence to use,
                reproduce and communicate to the public the User Content and to
                sub-license other people to use and view the User Content. You warrant
                that you are legally entitled to submit, upload, post or transmit the
                User Content to, on or through this App and have obtained all necessary
                licences, consents and approvals in relation to the User Content
                (including intellectual property licences) to enable you to submit,
                upload, post or transmit the User Content to, on or through this App and
                to permit Monash University and other people to deal with the User
                Content in accordance with the licences granted above.
            </p>

            <h2>14. Changes to the Service</h2>
            <p>
                Monash University reserves the right at any time to change, remove or
                discontinue any feature or function of this App, or all or any part of
                this App, either temporarily or permanently, with or without notice to
                you. From time to time Monash University may issue updates that add,
                modify and/or remove features from this App. These updates may be
                applied automatically with or without notice to you. These Terms will
                govern any updates provided by Monash University unless the update is
                accompanied by separate terms and conditions in which case those terms
                and conditions will apply.
            </p>

            <h2>15. Access to this App</h2>
            <p>
                Access to this App depends on telecommunications and internet service
                providers and other external factors and Monash University can not
                guarantee the availability of this App at all times or at any specific
                times. While Monash University will take precautions to ensure this App
                is secure, no data transmission over the Internet can be guaranteed as
                totally secure.
            </p>

            <h2>16. Third Party Websites</h2>
            <p>
                This App may cause the device through which you gain access to this App
                to display URLs or links to websites not controlled by Monash
                University. Those URLs or links are provided for convenience only and
                may not be current. Providing a URL or link should not be construed as
                an endorsement or approval of the third-party websites by Monash
                University, and Monash University is not responsible for the content of
                third-party websites.
            </p>

            <h2>17. Disclaimers and Liability of Monash University</h2>
            <p>
                MONASH UNIVERSITY DOES NOT WARRANT NOR REPRESENT THAT USE OF THIS APP
                WILL NOT INFRINGE THE RIGHTS OF THIRD PARTIES, OR THAT THIS APP WILL
                MEET YOUR REQUIREMENTS OR THAT IT WILL OPERATE IN AN UNINTERRUPTED OR
                ERROR-FREE MANNER, OR BE COMPATIBLE OR INTEGRATE WITH YOUR COMPUTER
                SYSTEMS. ALL WARRANTIES WHICH WOULD OTHERWISE BE IMPLIED INTO THIS
                AGREEMENT ARE EXCLUDED AS FAR AS PERMITTED BY LAW. IF ANY LEGISLATION
                IMPLIES OR APPLIES IN THESE TERMS ANY CONDITION, WARRANTY OR GUARANTEE,
                AND THAT LEGISLATION AVOIDS OR PROHIBITS PROVISIONS IN A CONTRACT
                EXCLUDING OR MODIFYING THE APPLICATION OF OR EXERCISE OF OR LIABILITY
                UNDER THE CONDITION, WARRANTY OR GUARANTEE, THE CONDITION, WARRANTY OR
                GUARANTEE IS DEEMED TO BE INCLUDED IN THESE TERMS.
            </p>

            <h2>18. Termination</h2>
            <p>
                If you fail to comply with any part of these Terms, Monash University
                may terminate this agreement, your Account and your right to use this
                App, by notice to you via your registered email with us. Termination of
                this agreement will not affect any rights or liabilities you or Monash
                University have accrued up to that time. Upon termination of this
                agreement, you must stop using and accessing this App.
            </p>

            <h2>19. General</h2>
            <p>
                You may not assign, transfer or otherwise deal with the rights under the
                Terms without the prior written consent of Monash University. This
                agreement will be governed by and construed in accordance with the laws
                in force in the State of Victoria, Australia, and each party submits to
                the non-exclusive jurisdiction of the courts of that State. If any term
                of this agreement is held unenforceable or illegal for any reason, the
                Terms will remain otherwise in full force apart from that provision.
            </p>

            <h2>20. Policy Updates</h2>
            <p>
                The App may update its Terms & Conditions, and Privacy Policy from time to time.
                Questions, complaints or feedback about this App should be directed to:
                <a href="mailto:info.mchri@monash.edu">info.mchri@monash.edu</a>
            </p>
        </div>
    )
}

export default TermsAndPrivacy
